export const isIOS = () => /iPhone|iPad|iPod/.test(navigator.platform);
export const isAndroid = () => /Android/.test(navigator.userAgent);
